import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { formatPrice } from '../../utils/formatterUtils';
import { getVenditeDashboard } from '../../services/venditeService';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChartColumn, faHome} from "@fortawesome/free-solid-svg-icons";

const TABS = {
  UNITS: 'units',
  BOXES: 'boxes',
};

function badgeClass(tag) {
  switch (tag) {
    case 'Venduto':
      return 'ok';
    case 'Da compromissare':
      return 'warn';
    case 'Preliminare':
      return 'att';
    default:
      return 'info';
  }
}

export default function VenditeCard() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [tab, setTab] = useState(TABS.UNITS);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await getVenditeDashboard(id);
        setData(res);
      } catch (err) {
        console.error('Errore recupero vendite dashboard', err);
      }
    }
    fetchData();
  }, [id]);

  if (!data) return null;

  const { soldPercentage, soldCount, totalUnits, units, boxes, totalUnitValue, totalBoxValue } = data;
  const sortedUnits = [...units].sort((a, b) => a.name.localeCompare(b.name, 'it', { numeric: true, sensitivity: 'base' }));
  const sortedBoxes = [...boxes].sort((a, b) => a.name.localeCompare(b.name, 'it', { numeric: true, sensitivity: 'base' }));
  const list = tab === TABS.UNITS ? sortedUnits : sortedBoxes;
  const totalValue = tab === TABS.UNITS ? totalUnitValue : totalBoxValue;

  return (
    <article className="card-dash">
      <h3>Proprietà del Progetto <span className="h-ico">{<FontAwesomeIcon icon={faChartColumn} />}</span></h3>
      <div className="mini-header">
        <div className="legend"><strong>Unità Vendute</strong></div>
        <div className="right">{Math.round(soldPercentage)}%</div>
      </div>
      <div className="progress"><span style={{ width: `${soldPercentage}%` }}></span></div>
      <div className="bar-legend"><span>{soldCount} vendute</span><span>{totalUnits} totali</span></div>

      <div className="tabs">
        <button className={tab === TABS.UNITS ? 'active' : ''} onClick={() => setTab(TABS.UNITS)}>unità immobiliari</button>
        <button className={tab === TABS.BOXES ? 'active' : ''} onClick={() => setTab(TABS.BOXES)}>box</button>
      </div>

      <div className="unit-list">
        {list.map((u) => (
          <div className="unit" key={`${tab}-${u.name}`}>
            <div className="left">
              <div className="name">{u.name}</div>
              <div className="type">{tab === TABS.UNITS ? 'unità immobiliare' : 'box'}</div>
            </div>
            <div className="right">
              <div className="price">{formatPrice(u.price)}</div>
              <span className="meta">{u.cliente || '—'}</span>
              <span className={`badge ${badgeClass(u.tag)}`}>{u.tag}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="totali">
        <span className="">Totale Proprietà: {list.length}</span>
        <span>Valore Totale: {formatPrice(totalValue)}</span>
      </div>
    </article>
  );
}
